import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export interface MetricCardItem
{
  label: string;
  value: string | number;
  icon: string;
  color: string;
  description: string;
}

@Component({
  selector: 'app-metric-cards',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './metric-cards.component.html',
  styleUrl: './metric-cards.component.scss',
})
export class MetricCardsComponent
{
  @Input() cards: MetricCardItem[] = [];
}
